module.exports = __webpack_public_path__ + "img/filter-outline.b5476637.svg";